import { Plugin, PluginListenerHandle, registerPlugin } from '@capacitor/core'

const CMPPlugin = registerPlugin<CMPPlugin>('CMPPlugin', {
  web: () => new WebCMPPlugin(),
})
export default CMPPlugin

export interface CMPPlugin extends Plugin {
  openConfig(options: { forceOpen: boolean }): Promise<void>
  hasConsent(options: { key: string }): Promise<{ hasConsent: boolean }>
  hasAppleTrackingConsent(): Promise<{ hasConsent: boolean }>
}

// this is just for tests, a real web implemention of CMPPlugin is not needed
export class WebCMPPlugin implements CMPPlugin {
  openConfig(options: { forceOpen: boolean }): Promise<void> {
    return undefined
  }

  hasConsent(options: { key: string }): Promise<{ hasConsent: boolean }> {
    return undefined
  }

  hasAppleTrackingConsent(): Promise<{ hasConsent: boolean }> {
    return undefined
  }

  addListener(
    eventName: string,
    listenerFunc: (...args: any[]) => any
  ): Promise<PluginListenerHandle> {
    return undefined
  }

  removeAllListeners(): Promise<void> {
    return undefined
  }
}

export enum CookieVendorId {
  sciper = 'c75708',
  consentManager = 's23',
  googleAnalytics = 's26',
  googleTagManager = 's905',
  googleAds = 's1',
  meta = 's7',
}
